function init(){
const body = document.body;
// const cooperateForm = document.getElementsByClassName('popup__form')[0];
const menus = {
	contact: {
		triggerClass:'header__contact',
		contentClass: 'header__contact-list',
	},
	headerLanguage: {
		triggerClass:'header__language',
		contentClass: 'header__language-list',
	},
	headerMenu: {
		triggerClass:'header__menu',
		contentClass: 'header__menu-body',
	},
	footerLanguage: {
		triggerClass:'footer__language',
		contentClass: 'footer__language-list',
	},
	footerSubmenus: {
		triggerClass:'footer__card-menu-item',
		contentClass: 'footer__card-sublist',
	},
}
const tabs = {
	links: {
		triggerClass:'header__links',
	},
	contacts: {
		triggerClass:'header__contacts',
	},
	footer: {
		triggerClass:'footer__card-title',
		contentClass: 'footer__card-list',
	},
}
const mores = {
	footer: {
		triggerClass: 'footer__more',
		hideContentClass: 'footer__card-list--hidden',
		showedListLength: 11,
	},
}
const closeAllMenus = closeMenus(menus);
const showModalById = showModal({
	closeButtonClass: 'popup__modal-close',
	modalContentClass: 'modal',
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const hideCurrentModal = hideModal({
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const switchDocumentsActiveTab = switchActiveTab({
	triggerClass: 'info__tabs', contentClass: 'info__documents'
});
const actions = {
	openModal: ({ openModal }) => {
		closeAllMenus();
		showModalById(openModal);
	},
}
// const timeLabelElements = getCountryTimeLabelElements([
// 	'header__contact-time',
// 	'header__contacts-time',
// 	'footer__card-time',
// ]);

for (const prop in menus) {
	body.addEventListener('click', toggleMenu(menus[prop], closeAllMenus));
}

for (const prop in tabs) {
	body.addEventListener('click', toggleTab(tabs[prop]));
}

for (const prop in mores) {
	const moreElements = document.getElementsByClassName(mores[prop].triggerClass)
	const toggleMoreCb = toggleMore(mores[prop])

	for (const moreElement of moreElements) {
		toggleMoreCb({ target: moreElement });
	}

	body.addEventListener('click', toggleMoreCb);
}

setCooperateFormHandlers();
setToDirectorFormHandlers();
// setCountryTimeLabelOffsetAndTime(timeLabelElements);
setRefreshCountryTimeInterval();
// setLanguagesAndLinks([
// 	...document.getElementsByClassName('header__language-list'),
// 	...document.getElementsByClassName('footer__language-list'),
// ]);
loadGoogleAnalytics();
body.addEventListener('click', (e) => {
	const { target } = e

	for (const prop in menus) {
		const { triggerClass, contentClass } = menus[prop];
		const menuTrigger = target.closest('.' + triggerClass);
		const menuContent = target.closest('.' + contentClass);

		if (menuTrigger || menuContent) {
			return;
		}
	}

	closeAllMenus();
});
body.addEventListener('click', createAnchorClickHandler(actions));
body.addEventListener('click', switchDocumentsActiveTab);
const setCountryCode = (country) => {
	intlTelInput(document.getElementById('cooperate_phone'), {
		autoHideDialCode: false,
		autoPlaceholder: 'aggressive',
		initialCountry: 'auto',
		separateDialCode: true,
		formatOnDisplay: false,
		preferredCountries: [
			'ua',
			'us'
		],
		customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
			return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
		},
		geoIpLookup: cb => cb(country),
	});
	intlTelInput(document.getElementById('to_director_phone'), {
		autoHideDialCode: false,
		autoPlaceholder: 'aggressive',
		initialCountry: 'auto',
		separateDialCode: true,
		formatOnDisplay: false,
		preferredCountries: [
			'ua',
			'us'
		],
		customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
			return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
		},
		geoIpLookup: cb => cb(country),
	});
}

getCountryCode().then(setCountryCode);

// sendRequest('https://ipapi.co/json')
// 	.then((res) => res.json())
// 	.then(({ country_code }) => {
// 		setCountryCode(country_code || 'us')
// 	})
// 	.catch(e => {
// 		setCountryCode('us')
// 	});
function switchActiveTab ({ triggerClass, contentClass }) {
	const attributeName = 'data-index';
	const modifier = '--active';
	const setActiveState = (index, className, elements) => {
		elements.forEach((element, idx) => {
			if (idx === index) {
				addClassToElement(element, className, modifier);
			} else {
				removeClassFromElement(element, className, modifier);
			}
		})
	}
	const triggerElements = Array.from(document.getElementsByClassName(triggerClass)[0].children);
	const contentElements =  Array.from(document.getElementsByClassName(contentClass));

	triggerElements.forEach((element, idx) => {
		element.setAttribute(attributeName, idx.toString());
	})

	return (e) => {
		const { target } = e;
		const { dataset, tagName } = target;

		if (tagName !== 'LI' || !dataset.index) {
			return;
		}

		setActiveState(parseInt(dataset.index), triggerClass, triggerElements);
		setActiveState(parseInt(dataset.index), contentClass, contentElements);
	}
}

}init();